import React from 'react'
import "./ScrollAnimation.css"

const ScrollAnimation = ({ component }) => {


    React.useEffect(() => {

        function reveal() {
            var reveals = document.querySelectorAll(".reveal");

            for (var i = 0; i < reveals.length; i++) {
                var windowHeight = window.innerHeight;
                var elementTop = reveals[i].getBoundingClientRect().top;
                var elementVisible = 150;

                if (elementTop < windowHeight - elementVisible) {
                    reveals[i].classList.add("active");
                } else {
                    reveals[i].classList.remove("active");
                }
            }
        }

        window.addEventListener("scroll", reveal);


    });

    return (


        <section className='scroll-section'>
            <div class="container reveal">
                {component}
            </div>
        </section>
    )
}

export default ScrollAnimation